import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Image, ImageOrientationEnum } from '../../core';
import { BaseComponent } from '../../shared';


/**
* Image previw modal component.
*/
@Component({
	selector: 'attachment-preview',
	templateUrl: './attachment-preview.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class AttachmentPreviewComponent extends BaseComponent {

	protected activeModal = inject(NgbActiveModal);

	fileName = signal<string | null>(null);
	set image(img: Image) {
		this._image.set(img);
	}

	private readonly _image = signal<Image | undefined>(undefined);
	protected url = computed(() => this._image()?.url ?? '');
	protected isFlipHor = computed(() => this._image()?.orientation === ImageOrientationEnum.Horizontal);
	protected isFlipVer = computed(() => this._image()?.orientation === ImageOrientationEnum.Vertical);

}
